var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TbMoodEmpty } from '../../icons';
import { Col, Row, Div, Title, Label, Code, Button, Colors } from '../../components';
export var Page404 = function (_a) {
    var goBack = _a.goBack, homeLink = _a.homeLink, useLegacyLink = _a.useLegacyLink, useReactLink = _a.useReactLink;
    var goBackFn = null;
    homeLink = homeLink || '/';
    if (!useLegacyLink && !useReactLink)
        useReactLink = true;
    if (typeof goBack === 'undefined')
        goBack = true;
    if (typeof goBack === 'function')
        goBackFn = goBack;
    return (_jsxs(Row, __assign({ columns: true }, { children: [_jsx(Col, __assign({ center: true, padding: 10 }, { children: _jsx(TbMoodEmpty, { size: 126, color: Colors['surface-5'] }) })), _jsx(Col, __assign({ padding: 10 }, { children: _jsx(Title, __assign({ textCenter: true, marginBottom: 10, bold: true, large: true }, { children: "No se encontr\u00F3 la p\u00E1gina indicada." })) })), _jsx(Col, __assign({ padding: 14 }, { children: _jsxs(Div, { children: [_jsxs(Label, __assign({ p: true, marginBottom: 4, normal: true }, { children: ["Revisa que la ", _jsx(Code, { children: "url" }), " sea correcta y reitenta"] })), _jsx(Label, __assign({ p: true, marginBottom: 4, normal: true }, { children: "Revisa tu conexi\u00F3n a internet" }))] }) })), goBack && _jsx(Col, __assign({ center: true, padding: 14 }, { children: _jsx(Button, __assign({ buttonMedium: true, pointer: true, minWidth: 150, fontSize: 14, label: "Ir al inicio" }, {
                    onClick: goBackFn && goBack,
                    reactLink: !goBackFn && useReactLink && homeLink,
                    legacyLink: !goBackFn && useLegacyLink && homeLink,
                })) }))] })));
};
